import '../styles/PageGlobal.css';
import './ContactListPage.css';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ReferenceButton from '../components/ReferenceButton';
import { ContactService } from '../services/ContactService.js';

export default function ContactListPage() {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContacts = useCallback(async () => {
    const service = new ContactService();
    setLoading(true);
    try {
      const data = await service.getAllContacts();
      setContacts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchContacts(); }, [fetchContacts]);

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer définitivement ce contact ?')) return;
    try {
      await new ContactService().deleteContact(id);
      fetchContacts();
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div className="contact-status contact-status-loading">Chargement…</div>;
  if (error) return <div className="contact-status contact-status-error">{error}</div>;

  return (
    <div className="containerMain contact-container">
      <div className="contact-header">
        <h1 className="contact-title">Liste des Contacts</h1>
        <div className="contact-header-actions">
          <ReferenceButton to="/contact_new" className="contact-btn contact-btn-success">
            + Créer un Contact
          </ReferenceButton>
        </div>
      </div>
      <p className="contact-protected">Ceci est un contenu protégé</p>

      <div className="contact-table-wrapper">
        <table className="contact-table">
          <thead>
            <tr>
              <th>N</th><th>Nom</th><th>Prénom</th><th>Email 1</th><th>Email 2</th>
              <th>Téléphone 1</th><th>Téléphone 2</th><th>Société</th><th>Commentaire</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact, index) => (
              <tr key={contact.id}>
                <td>{index + 1}</td>
                <td className="contact-nom">{contact.nom || ''}</td>
                <td>{contact.prenom || ''}</td>
                <td className="contact-email">{contact.email1 || ''}</td>
                <td className="contact-email">{contact.email2 || ''}</td>
                <td>{contact.telephone1 || ''}</td>
                <td>{contact.telephone2 || ''}</td>
                <td>{contact.societe || ''}</td>
                <td>{contact.commentaire || ''}</td>
                <td className="contact-action-cell">
                  <button className="contact-btn contact-btn-yellow" onClick={() => navigate(`/contact_edit/${contact.id}`)}>Edit</button>
                  <button className="contact-btn contact-btn-red" onClick={() => handleDelete(contact.id)}>Suppr.</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
       <div className="contact-footnotes">
        <p>* Cliquez sur "Edit" pour modifier un contact, "Save" pour valider les changements</p>
        
      </div>
    </div>
    
  );
}
